import { createContext } from "react";
import type { YAxisActions } from "../YAxisProvider.types";

const YAxisActionsContext = createContext<YAxisActions | undefined>(undefined);
YAxisActionsContext.displayName = "YAxisActionsContext";

export default YAxisActionsContext;
